<template>
  <v-container
    fluid
    tile
    class="pa-0"
    :style="'background-color: ' + this.webTheme.colors.content.hexa"
  >
    <v-row justify="center" no-gutters>
      <v-col xs="12" :sm="component.settings.cols">
        <v-sheet :height="height" tile :color="component.settings.color.hexa">
          <template>
            <v-row
              no-gutters
              :justify="component.block.justify"
              :align="component.block.align"
              class="fill-height"
            >
              <v-col xs="12" :sm="component.block.cols">
                <v-col>
                  <v-card
                    tile
                    elevation="0"
                    :class="titleBlock"
                    :style="topMargin + bottomMargin"
                  >
                    <v-row no-gutters>
                      <view-text
                        :settings="component.textBody"
                        :value="pageBody"
                      ></view-text>
                    </v-row>
                  </v-card>

                  <div v-if="pageResources.length > 0">
                    <v-row no-gutters class="mb-3">
                      <span :style="resourcesHeadingStyle">Resources</span>
                    </v-row>
                    <v-row
                      v-for="(item, i) in pageResources"
                      :key="i"
                      no-gutters
                      class="py-2"
                      align="center"
                    >
                      <span
                        @click="openResource(item.url)"
                        v-if="item.type === 'file'"
                        :style="resourcesListStyle"
                        class="pointer"
                        ><v-icon :color="component.textBody.color" class="mr-1"
                          >attach_file</v-icon
                        >{{ item.description }} ( {{ item.filename }} )</span
                      >
                      <span
                        @click="openResource(item.url)"
                        v-else
                        :style="resourcesListStyle"
                        class="pointer"
                        ><v-icon :color="component.textBody.color" class="mr-2"
                          >launch</v-icon
                        >{{ item.description }}</span
                      >
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </template>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewText from "../Text.vue";
export default {
  components: {
    ViewText
  },
  props: ["component", "index"],
  created() {
    // this.$store.dispatch('getSamplePages')
  },
  computed: {
    resourcesHeadingStyle() {
      return (
        "font-size: " +
        this.component.textBody.size +
        "px; " +
        "color: " +
        this.component.textBody.color +
        "; " +
        "font-family: " +
        this.component.textBody.font +
        "; " +
        "font-weight: 800 !important;"
      );
    },
    resourcesListStyle() {
      return (
        "font-size: " +
        this.component.textBody.size +
        "px; " +
        "color: " +
        this.component.textBody.color +
        "; " +
        "font-family: " +
        this.component.textBody.font +
        ";"
      );
    },
    webTheme() {
      return this.$store.getters.currentProgram.webTheme;
    },
    activeSecMenu() {
      return this.$store.getters.activeSecMenu;
    },
    pageBody() {
      return this.activeSecMenu && this.activeSecMenu.body
        ? this.activeSecMenu.body
        : "";
    },
    pageResources() {
      return this.activeSecMenu && this.activeSecMenu.resources
        ? this.activeSecMenu.resources
        : [];
    },
    primaryMenus() {
      return this.$store.getters.primaryMenus;
    },
    secondaryMenus() {
      return this.$store.getters.secondaryMenus;
    },
    menuDetail() {
      return (
        this.primaryMenus.find(
          menuDetail => menuDetail.content === this.$route.params.id
        ) ||
        this.secondaryMenus.find(
          menuDetail => menuDetail.content === this.$route.params.id
        ) ||
        {}
      );
    },
    gradient() {
      if (this.component.screen.type === "gradient") {
        var screen = this.component.screen;
        var gradient =
          screen.direction +
          ", rgba(" +
          screen.fromColor.rgba.r +
          ", " +
          screen.fromColor.rgba.g +
          ", " +
          screen.fromColor.rgba.b +
          ", " +
          screen.fromColor.rgba.a +
          ") " +
          "0%, rgba(" +
          screen.toColor.rgba.r +
          ", " +
          screen.toColor.rgba.g +
          ", " +
          screen.toColor.rgba.b +
          ", " +
          screen.toColor.rgba.a +
          ") " +
          screen.height +
          "%";
        return gradient;
      } else if (this.component.screen.type === "screen") {
        var screen2 = this.component.screen;
        var screenColor =
          screen2.direction +
          ", rgba(" +
          screen2.color.rgba.r +
          ", " +
          screen2.color.rgba.g +
          ", " +
          screen2.color.rgba.b +
          ", " +
          screen2.color.rgba.a +
          "), rgba(" +
          screen2.color.rgba.r +
          ", " +
          screen2.color.rgba.g +
          ", " +
          screen2.color.rgba.b +
          ", " +
          screen2.color.rgba.a +
          ")";
        return screenColor;
      } else {
        return "to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)";
      }
    },
    grid() {
      return this.$store.getters.grid;
    },
    topMargin() {
      let val = "";
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          val = 45;
          break;
        case "sm":
          val = 65;
          break;
        case "md":
          val = this.component.block.padding.top;
          break;
        case "lg":
          val = this.component.block.padding.top;
          break;
        case "xl":
          val = this.component.block.padding.top;
          break;
        default:
          console.log("There was an error");
      }
      return "padding-top: " + val + "px; ";
    },
    bottomMargin() {
      let val = "";
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          val = 45;
          break;
        case "sm":
          val = 65;
          break;
        case "md":
          val = this.component.block.padding.bottom;
          break;
        case "lg":
          val = this.component.block.padding.bottom;
          break;
        case "xl":
          val = this.component.block.padding.bottom;
          break;
        default:
          console.log("There was an error");
      }
      return "padding-bottom: " + val + "px; ";
    },
    titleBlock() {
      var padding = this.component.block.padding;
      return (
        this.grid.block +
        " pl-md-" +
        padding.left +
        " pr-md-" +
        padding.right +
        " pl-sm-" +
        Math.ceil(padding.left / 2) +
        " pr-" +
        Math.ceil(padding.left / 2)
      );
    },
    hasWebThemePendingUpdates() {
      return this.$store.getters.hasWebThemePendingUpdates;
    },
    height() {
      return "";
      // if (this.component.settings.heightContext == 'px') {
      //   return this.component.heightValue.px + 'px'
      // } else {
      //   return this.component.heightValue.vh + 'vh'
      // }
    },
    imageHeight() {
      if (this.component.settings.heightContext == "px") {
        return this.component.heightValue.px + this.component.overlap.px + "px";
      } else {
        return this.component.heightValue.vh + this.component.overlap.vh + "vh";
      }
    },
    image() {
      if (this.component.settings.mode === "color") {
        return "";
      } else {
        return this.component.settings.image;
      }
    },
    menuMargin() {
      let val = 0;
      var height = this.webTheme.shared.menuHeight;
      var arr = this.webTheme.header.components;
      var result = arr.find(el => el.id === "MenuBar");
      if (result && result.settings.overlap == true) {
        val = "margin-top: " + height + "px; ";
      } else {
        val = "";
      }
      return val;
    }
  },
  watch: {
    menuDetail(val, prevVal) {
      if (val.content !== prevVal.content && val.content) {
        this.$store.dispatch("fetchScreenData", {
          contentId: val.content
        });
      }
    }
  },
  mounted() {
    if (this.menuDetail.content) {
      this.$store.dispatch("fetchScreenData", {
        contentId: this.menuDetail.content
      });
    }
  },
  methods: {
    openResource(url) {
      window.open(url, "_blank", "noreferrer");
    },
    handleEditor(val) {
      this.editing = val;
      if (val === "preview") {
        this.previewCols = 11;
      } else {
        this.previewCols = 8;
      }
    },
    handleSave() {
      this.$store.dispatch("updateWebTheme", this.webTheme);
      this.$store.dispatch("setHasWebThemePendingUpdates", false);
      this.$store.dispatch("editingField", {});
    }
  }
};
</script>

<style scoped>
.theme-page {
  padding: 0px 10px 0px 0px !important;
}
.sticky-footer {
  position: fixed;
  background: transparent;
  bottom: 0px;
  left: 290px;
  margin-bottom: 10px;
  z-index: 1000 !important;
}
.pointer {
  cursor: pointer;
}
</style>
